<script>
import Layout from '../layouts/main'
import PageHeader from '@/components/page-header'
import axios from "axios";
import router from "@/router";
import {
  authFackMethods
} from "@/state/helpers";

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "Volunteer Dashboard",
      },
    ],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "",
          href: "",
        },
      ],
      currentUserData: JSON.parse(localStorage.getItem('user')),
      userTypes: [{ value: '3', text: 'Mentor' }, { value: '4', text: 'Volunteer' }],
      notifications: [],
      registeredUsers: [],
      registeredUsersCount: {},
      mentorAnalyticsDonutChart: {},
      volunteerAnalyticsDonutChart: {},
      searchForm: {
        username: null,
        psv_check: null,
        user_type: null
      },
      isName: false,
      isPsvCheck: false,
      isUserType: false,
      isSearching: false,
      isLoading: false,
      noRecord: false,
      isLoadingNotifications: false,
      noRecordNotifications: false,
      searchBy: '',
    }
  },
  mounted() {
    this.getNotifications();
    this.getRegisteredUsers();
    this.getRegisteredUsersCount();
  },
  methods: {
    getNotifications() {
      this.isLoadingNotifications = true;
      this.noRecordNotifications = false;
      axios.get('admin/notifications/receiver/all?pagination=true&per_page=10').then(res => {
        this.notifications = res.data.response.data;
        this.isLoadingNotifications = false;
        if (!res.data.response.data.length) {
          this.noRecordNotifications = true;
        }
      })
    },

    getRegisteredUsers() {
      this.noRecord = false;
      this.isLoading = true;
      let filter = '';
      if (this.searchForm.username) {
        filter += '&username=' + this.searchForm.username
      }
      if (this.searchForm.psv_check) {
        filter += '&psv_check=' + this.searchForm.psv_check
      }
      if (this.searchForm.user_type) {
        filter += '&user_type_id=' + this.searchForm.user_type
      }
      //if not admin
      if (this.currentUserData.user_type_id !== 1) {
        filter += '&location=yes'
        filter += '&user_id=' + this.currentUserData.id;
      }

      axios.get('admin/users/all/registered?pagination=true&per_page=10' + filter).then(res => {
        this.registeredUsers = res.data.response.data;
        this.isLoading = false;
        if (!res.data.response.data.length) {
          this.noRecord = true;
        }
      }).catch((err) => {
        if (err.response) {
          if (err.response.status == 401) {
            this.logout();
          }
        }
      })
    },

    ...authFackMethods,

    getRegisteredUsersCount() {
      axios.get('admin/users/all/registered/count?pagination=true').then(res => {
        this.registeredUsersCount = res.data.response;
        const mentorAnalyticsDonutChart = {
          series:
            [
              this.registeredUsersCount.mentor.active ?? 0,
              this.registeredUsersCount.mentor.progress ?? 0,
              // this.registeredUsersCount.mentor.inactive ?? 0
            ],
          chartOptions: {
            // chart: {
            //   type: 'donut',
            //   height: 240,
            // },
            labels: [
              'Active',
              'In Process',
              // 'Inactive'
            ],
            colors: [
              '#59c490',
              '#f1b44c',
              // '#f06969'
            ],
            legend: {
              show: false,
            },
            // plotOptions: {
            //   pie: {
            //     donut: {
            //       size: '50%',
            //     }
            //   }
            // }
          }
        };
        const volunteerAnalyticsDonutChart = {
          series:
            [
              this.registeredUsersCount.volunteer.active ?? 0,
              this.registeredUsersCount.volunteer.progress ?? 0,
              // this.registeredUsersCount.volunteer.inactive ?? 0
            ],
          chartOptions: {
            // chart: {
            //   type: 'donut',
            //   height: 240,
            // },
            labels: [
              'Active',
              'In Process',
              // 'Inactive'
            ],
            colors: [
              '#59c490',
              '#f1b44c',
              // '#f06969'
            ],
            legend: {
              show: false,
            },
            // plotOptions: {
            //   pie: {
            //     donut: {
            //       size: '50%',
            //     }
            //   }
            // }
          }
        };
        this.mentorAnalyticsDonutChart = mentorAnalyticsDonutChart;
        this.volunteerAnalyticsDonutChart = volunteerAnalyticsDonutChart;
      })
    },

    showMessageBox(notification) {
      router.push(`/email/reademail/${notification.id}`);
    },

    viewAllregisteredUsers() {
      router.push({ name: 'registration-progress' })
    },

    showEmails() {
      router.push({ name: 'emails' })
    },

    searchOption(event) {
      this.searchForm = {
        username: null,
        psv_check: null,
        user_type: null,
      };
      let selectedValue = event.target.value
      if (selectedValue == '') {
        this.resetSearch();
      }
      if (selectedValue == 'name') {
        this.getRegisteredUsers();
        this.isName = true;
        this.isPsvCheck = false;
        this.isUserType = false;
        this.isSearching = true;
      }
      if (selectedValue == 'psv_check') {
        this.isName = false;
        this.isPsvCheck = true;
        this.isUserType = false;
        this.isSearching = true;
      }
      if (selectedValue == 'user_type') {
        this.isName = false;
        this.isPsvCheck = false;
        this.isUserType = true;
        this.isSearching = true;
      }
    },

    searchRegisteredUsers() {
      this.getRegisteredUsers();
    },

    resetSearch() {
      this.searchForm = {
        username: null,
        psv_check: null,
        user_type: null,
      };
      this.isSearching = false;
      this.isName = false;
      this.isPsvCheck = false;
      this.isUserType = false;
      this.searchBy = '';
      this.getRegisteredUsers();
    },
    getFullName(user) {
      let fullname = '';
      if (user.first_name && user.first_name.length) {
        fullname += user.first_name;
      }
      // if( user.middle_name.toLowerCase() != 'nmn' && user.middle_name && user.middle_name.length ){
      //     fullname += ' ' + user.middle_name;
      // }
      if (user.last_name && user.last_name.length) {
        fullname += ' ' + user.last_name;
      }
      return fullname;
    }

  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!--Notifications-->
    <!-- <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Notifications</h5>
          </div>

        </div>

        <div class="mb-4">
          <button type="button" @click="showEmails" class="btn btn-primary btn-sm">
            <i class="bx bx-mail-send font-size-18 align-middle me-1"></i>
            Message Inbox
          </button>
        </div>

        <div class="table-responsive ">
          <table class="table align-middle mb-0">
            <tbody>
            <tr>
              <th scope="col">From</th>
              <th scope="col">Subject</th>
              <th scope="col">Received</th>
              <th scope="col">Action</th>
            </tr>
            <tr v-if="noRecordNotifications">
              <td colspan="4" class="p-0">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </td>
            </tr>

            <tr v-if="isLoadingNotifications">
              <td colspan="4" class="text-center p-0">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </td>
            </tr>
            <tr v-else v-for="(notification, notificationIndex) in notifications" :key="notificationIndex">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <a href="#" class="text-dark">
                    {{notification.sender.username}}
                  </a>
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  {{notification.subject}}
                </h5>
              </td>
              <td>
                <p class="text-muted mb-0 zys">
                  {{new Date(notification.created_at).toISOString().substr(0,10)}}
                </p>
              </td>
              <td><button type="button" @click="showMessageBox(notification)" class="btn btn-primary btn-sm">
                <i class="bx bxs-show font-size-18 align-middle me-1"></i>
                View Message </button>
              </td>
            </tr>

            </tbody>
          </table>
        </div>

      </div>
    </div> -->

    <!--Registration Progress-->
    <!-- <div class="card" v-if="(currentUserData['user_type_id'] !== 7 && currentUserData['user_type_id'] !== 8 && currentUserData['user_type_id'] !== 9)">
      <div class="card-body">

        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Application Progress</h5>
          </div>

        </div>

        <form class="row align-items-center form-inline mb-4 border p-3 m-0">
          <div class="col-md-12">
            <h4 class="font-size-14">Search By:</h4>
          </div>
          <div class="col-md-4">
            <select
                class="form-select custom-select" v-model="searchBy" @change="searchOption($event)">
              <option value="">Select Option</option>
              <option value="name">Name</option>
              <option value="psv_check">Status</option>
              <option value="user_type">User Type</option>
            </select>
          </div>
          <div class="col-md-2 sm-hidden xs-hidden"></div>
          <div class="col-md-6 pull-right">
            <div class="row app-search pt-0 pb-0">

              <div class="col-md-12 d-flex">
                <input v-if="isName"
                    v-model="searchForm.username"
                    type="text"
                    class="ps-4 form-control"
                    placeholder="Type User Name"
                />
                <input v-if="isPsvCheck"
                    v-model="searchForm.psv_check"
                    type="text"
                    class="ps-4 form-control"
                    placeholder="Type PSV Check"
                />
                <b-form-select v-if="isUserType" class="form-select" v-model="searchForm.user_type"
                               :options="userTypes">
                  <option slot="first" :value="null" disabled>Select User Type</option>
                </b-form-select>

                <b-button v-if="isSearching" class="btn-find" id="show-btn" @click="searchRegisteredUsers"
                          variant="primary" title="Search">
                  <i class="bx bx-search-alt-2"> Search</i>
                </b-button>

                <b-button v-if="isSearching" class="btn-reset ms-2" id="show-btn" @click="resetSearch"
                          variant="primary" title="Reset">
                  <i class="bx bx-reset"> Reset</i>
                </b-button>

              </div>
            </div>
          </div>
        </form>


        <div class="table-responsive">
          <table class="table table-striped align-middle mb-0">
            <caption class="text-center">
              <button type="button" @click="viewAllregisteredUsers" class="btn btn-primary btn-sm me-2">
              <i class="bx bxs-show font-size-18 align-middle me-1"></i>
              View All
            </button>
            </caption>

            <thead class="table-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Status</th>
              <th scope="col">Submission Date</th>
              <th scope="col">Type</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="noRecord">
              <td colspan="4" class="p-0">
                <p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
              </td>
            </tr>

            <tr v-if="isLoading">
              <td colspan="4" class="text-center p-0">
                <b-spinner
                    class="m-2"
                    variant="primary"
                    role="status"
                ></b-spinner>
              </td>
            </tr>
            <tr v-else v-for="(registeredUser, registeredUserIndex) in registeredUsers" :key="registeredUserIndex">
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <router-link
                      tag="a"
                      :to="`/registration-progress/user/${registeredUser.id}`"
                  >
                    {{registeredUser.first_name != null ? getFullName(registeredUser) : (registeredUser.username ? registeredUser.username : "N/A") }}
                  </router-link>
                </h5>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <span v-if="registeredUser.psv_check=='applicant'">Review Application</span>
                  <span v-else>{{registeredUser.user_current_status}}</span>
                </h5>
              </td>
              <td>
                <p class="text-muted mb-0">
                  {{registeredUser.date}}
                </p>
              </td>
              <td>
                <p class="text-muted mb-0">
                  {{registeredUser.UserType}}
                </p>
              </td>
            </tr>

            </tbody>
          </table>
        </div>

      </div>
    </div> -->

    <!--Resource Allocation-->
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Resource Allocation
            </h5>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 br-1">
            <h2 class="font-size-22 mb-4 text-center">Mentors
              ({{
                this.registeredUsersCount.mentor ? this.registeredUsersCount.mentor.active : 0 +
                  this.registeredUsersCount.mentor ? this.registeredUsersCount.mentor.progress : 0
              }})</h2>

            <div v-if="mentorAnalyticsDonutChart.series">
              <apexchart
                  class="apex-charts"
                  dir="ltr"
                  type="donut"
                  height="240"
                  :series="mentorAnalyticsDonutChart.series"
                  :options="mentorAnalyticsDonutChart.chartOptions"
              ></apexchart>
            </div>

            <div class="text-center mb-5 text-muted">
              <div class="row">
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-success me-1"></i>
                      Active
                    </p>
                    <h5 class="text-success">
                      {{ this.registeredUsersCount.mentor ? this.registeredUsersCount.mentor.active : '-' }}
                    </h5>
                  </div>
                </div>
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-warning me-1"></i>
                      In Process
                    </p>
                    <h5 class="text-warning">
                      {{ this.registeredUsersCount.mentor ? this.registeredUsersCount.mentor.progress : '-' }}
                    </h5>
                  </div>
                </div>
                <!-- <div class="col-4">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-danger me-1"></i>
                      Inactive
                    </p>
                    <h5 class="text-danger">
                      {{this.registeredUsersCount.mentor ? this.registeredUsersCount.mentor.inactive : '-'}}
                    </h5>
                  </div>
                </div> -->
              </div>
            </div>

<!--            <h4 class="mb-0 font-size-15">Location Wise Count:</h4>-->
            <hr class="mt-2">

            <ul class="m-auto p-0 lctn-count">
              <li v-for="(mentorLocationCount, mentorIndex) in this.registeredUsersCount.mentor ? this.registeredUsersCount.mentor.locations : '-'"
                  :key="mentorIndex" class="mt-3 d-flex justify-content-between align-items-baseline">
                <h6 class="font-size-13">{{ mentorLocationCount.name }}</h6>
                <div class="lctn-crcle">
                  <span>{{ mentorLocationCount.location_count }}</span>
                </div>
              </li>

            </ul>

          </div>

          <div class="col-xl-6">
            <h2 class="font-size-22 mb-4 text-center">Volunteers
              ({{
                this.registeredUsersCount.volunteer ? this.registeredUsersCount.volunteer.active : 0 +
                  this.registeredUsersCount.volunteer ? this.registeredUsersCount.volunteer.progress : 0
              }})
            </h2>
            <div v-if="volunteerAnalyticsDonutChart.series">
              <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="240"
                  type="donut"
                  :series="volunteerAnalyticsDonutChart.series"
                  :options="volunteerAnalyticsDonutChart.chartOptions"
              ></apexchart>
            </div>

            <div class="text-center mb-5 text-muted">
              <div class="row">
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-success me-1"></i>
                      Active
                    </p>
                    <h5 class="text-success">
                      {{ this.registeredUsersCount.volunteer ? this.registeredUsersCount.volunteer.active : '-' }}
                    </h5>
                  </div>
                </div>
                <div class="col-6">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-warning me-1"></i>
                      In Process
                    </p>
                    <h5 class="text-warning">
                      {{ this.registeredUsersCount.volunteer ? this.registeredUsersCount.volunteer.progress : '-' }}
                    </h5>
                  </div>
                </div>
                <!-- <div class="col-4">
                  <div class="mt-4">
                    <p class="mb-2 text-truncate">
                      <i class="mdi mdi-circle text-danger me-1"></i>
                      Inactive
                    </p>
                    <h5 class="text-danger">
                      {{this.registeredUsersCount.volunteer ? this.registeredUsersCount.volunteer.inactive : '-'}}
                    </h5>
                  </div>
                </div> -->
              </div>
            </div>

<!--            <h4 class="mb-0 font-size-15">Location Wise Count:</h4>-->
            <hr class="mt-2">

            <ul class="m-auto p-0 lctn-count">
              <li v-for="(volunteerLocationCount, volunteerIndex) in this.registeredUsersCount.volunteer ? this.registeredUsersCount.volunteer.locations : '='"
                  :key="volunteerIndex" class="mt-3 d-flex justify-content-between align-items-baseline">
                <h6 class="font-size-13">{{ volunteerLocationCount.name }}</h6>
                <div class="lctn-crcle">
                  <span>{{ volunteerLocationCount.location_count }}</span>
                </div>
              </li>

            </ul>
          </div>

      </div>
    </div>
    </div>

  </Layout>
</template>

<style scoped>
.br-1 {
  border-right: 3px solid #e3e3e3
}

.lctn-count {
  width: 60%;
}

.lctn-count li {
  padding-bottom: 8px;
  border-bottom: 1px solid #e3e3e3;
  font-weight: 600;
}

.lctn-count li:last-child {
  border-bottom: 0px;
}

.lctn-count .lctn-crcle {
  width: 50px;
  height: 50px;
  border: 5px solid #59c490;
  border-radius: 100%;
  text-align: center;
}

.lctn-count .lctn-crcle span {
  font-size: 13px;
  line-height: 40px;
}

.app-search input,
.app-search select {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.app-search .btn-find {
  width: 40%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow: none;
}

.app-search .btn-reset {
  width: 40%;
  font-size: 15px;
  box-shadow: none;
  border-radius: 30px;
}</style>
